var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineNoteRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75H7zM6.47 6.49 2.72 2.74a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l3.75 3.75c.29.29.29.77 0 1.06-.15.14-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.68 6.53a.754.754 0 0 1 0-1.06l3.75-3.75c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L3.74 6.53c-.14.15-.34.22-.53.22s-.38-.07-.53-.22zM7 10.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75H7z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 16V7.99c0-4.23-1.44-5.09-4.29-5.24H10c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c4.1.22 5.75 2.17 5.75 6.74V16c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM9 22.75c-5.62 0-6.75-2.59-6.75-6.77V9.01c0-.41.34-.75.75-.75s.75.34.75.75v6.97c0 3.72.73 5.27 5.25 5.27h6c.41 0 .75.34.75.75s-.34.75-.75.75H9z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.71 22.69a.751.751 0 0 1-.46-.69v-3c0-2.42 1.33-3.75 3.75-3.75h3c.3 0 .58.18.69.46.11.28.05.6-.16.82l-6 6c-.14.14-.34.22-.53.22-.1 0-.19-.02-.29-.06zM15.75 19v1.19l3.44-3.44H18c-1.58 0-2.25.67-2.25 2.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineNoteRemove);
export default __webpack_public_path__ + "static/media/vuesax-outline-note-remove.83b266daad2457d5abc09390d17328e9.svg";
export { ForwardRef as ReactComponent };